import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { NewBannerType } from "types/Banners";
import { fetchBanners } from "features/banners/fetchBanners";

interface UseBannersDataResult {
  bannersData: NewBannerType[] | null;
  bannersIsSuccess: boolean;
}

const useBannersData = (): UseBannersDataResult => {
  const { data, isSuccess }: UseQueryResult<NewBannerType[], Error> = useQuery({
    queryKey: ["banners"],
    queryFn: fetchBanners,
    enabled: true,
    staleTime: 5 * 6 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    bannersData: data || null,
    bannersIsSuccess: isSuccess,
  };
};

export default useBannersData;
